import {
  type BuildDetailsFieldsParams,
  field,
  fullName,
  readOnlyField,
  selectField,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildOpportunityInfoFields({
  dealCount,
  offer,
  opportunity,
  opportunityId,
}: BuildDetailsFieldsParams): Array<DetailField> {
  const opportunityInfo = opportunity?.opportunity_info;

  return (
    [
      field('Opportunity Owner', opportunityInfo?.opp_owner_lookup_name__c),
      field('Account Name', opportunity?.account_18_digit_id__c ?? offer?.vendor_account_id),
      field('Opportunity Name', opportunityInfo?.name),
      field('Second Vendor', undefined),
      readOnlyField('18 Character ID', opportunityId, 'Salesforce-owned identifier.'),
      selectField('Opportunity Record Type', undefined, ['Escapes - Pre Deal Review', 'Escapes Approved']),
      typedField('Close Date', undefined, 'date'),
      typedField('Contract Signed Date', undefined, 'date'),
      readOnlyField('Cost Price Currency', opportunityInfo?.cost_price_currency__c),
      field(
        'Campaign/Market Manager',
        fullName(
          opportunityInfo?.merchant_account_manager_first_name__c,
          opportunityInfo?.merchant_account_manager_last_name__c,
        ),
      ),
      selectField('Includes Solo Traveler Packages', undefined, ['Yes', 'No']),
      field('Reason For No Solo Packages', undefined, undefined, true),
      readOnlyField('Number of Deal Options', dealCount, 'Derived from Deal Options rows.'),
      typedField('Proposal Sent Date', undefined, 'datetime-local'),
      typedField('# of Proposal Sent', undefined, 'number'),
      selectField('Stage', undefined, ['Qualification', 'Proposal', 'Negotiation', 'Closed Won', 'Closed Lost']),
      typedField('Proposal Start', undefined, 'date'),
      selectField('Production Stages', undefined, ['Not Started', 'In Progress', 'Complete', 'Live']),
      typedField('Probability (%)', undefined, 'number'),
      selectField('Campaign Type', opportunityInfo?.campaign_type__c, [
        'FLASH - standard',
        'FLASH - flexi nights',
        'FLASH - Bundle Module',
      ]),
      selectField('Product Type', offer?.type, ['Hotel', 'Package', 'Experience']),
    ] satisfies Array<DetailField>
  ).map((detailField) => withLayout(detailField, { columns: 4 }));
}
